import { SelectOption } from "@iddataweb/idw-common-ui/types";

export const TMX_EVENT_TYPE_OPTIONS: Array<SelectOption> = [
    { label: "Account Creation", value: "ACCOUNT_CREATION" },
    { label: "OIDC Login", value: "LOGIN" }
];